import { decode } from "base-64"
import Cookies from "js-cookie"

function getHeadersformdata () {
    return {
      'Content-Type': 'multipart/form-data',
      "accept": "application/json",
      'Authorization':decode(Cookies.get('accessToken'))? `${decode(Cookies.get("accessToken"))}` : null,
      'Access-Control-Allow-Origin': '*',
      // "Content-Type": "application/json",
      //  'X-Frame-Options': 'SAMEORIGIN', 
      //  'X-XSS-Protection': '1; mode=block' 
    }
  }
  export default getHeadersformdata